module.exports = __webpack_public_path__ + "img/fond-troupeau3test.a8352b9e.png";